export default __webpack_public_path__ + "img/6223ad50d951b7d44ca3f417a265a3f5.png";